import { fetchData, apiURL } from './api_helper';

const update = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${payload.companyId}`;
    fetchData(endpointURL, 'put', payload.data).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const fetchAppSumoLicence = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/appsumo/${payload.uuid}`;
    fetchData(endpointURL, 'get').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const finalizeAppSumo = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/appsumo/${payload.uuid}`;
    fetchData(endpointURL, 'post', payload).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const companyProgress = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${payload.id}/progress`;
    fetchData(endpointURL, 'get').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const updateCompanyBillingInformation = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${payload.id}/billing`;
    fetchData(endpointURL, 'post', payload.billingInformation).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const uploadCompanyLogo = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${payload.companyId}/logo`;
    fetchData(endpointURL, 'post', payload.formData, 'multipart/form-data').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

const deleteCompany = companyId => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}companies/${companyId}`;
    fetchData(endpointURL, 'delete', {}).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

export default {
    update,
    fetchAppSumoLicence,
    finalizeAppSumo,
    companyProgress,
    updateCompanyBillingInformation,
    uploadCompanyLogo,
    deleteCompany,
};
